import React, {useContext} from 'react';
import {AppStoreContext, SESSION_STATUS} from "components/Mall/AppStore/AppStore";
import {ExceedApiContext} from "containers/App/ExceedApi";
import {List, Icon} from "react-onsenui";
import logo from 'containers/Main/mediumLogo.png'
import {useHistory} from "react-router";

export const switchProject = async (botId, ExceedApi, history, redirectUrl) => {
    await ExceedApi.loadInitialData(undefined, undefined, botId);
    history.push(redirectUrl);
}

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
    const ExceedApi = useContext(ExceedApiContext);
    const AppStore = useContext(AppStoreContext);
    let history = useHistory();

    const logout = () => {
        window.localStorage.clear();
        AppStore.setSessionStatus(SESSION_STATUS.UNSET);
    }

    const close = () => history.push('/');

    return <div className="flex_column flex-1" style={{height: "100vh"}}>

        <div className="exceed_toolbar">
            <img id="logo" alt="Exceed.ai" src={logo}/>

            <div className="details">
                <Icon
                    onClick={close}
                    style={{paddingRight: "10px"}}
                    size={{default: 32}}
                    icon={{default: 'times'}}
                />
            </div>
        </div>

        <div className="flex_row" style={{alignItems: "center", padding: "5px 0 5px 0"}}>
            <img alt="Exceed.ai" src={AppStore.getAdminDetails.imageURL}
                 style={{height: "90%", maxHeight: "50px", maxWidth: "50px", paddingRight: "5px"}}/>

            <div className="flex_column">
                <div>{`${AppStore.getAdminDetails.firstName} ${AppStore.getAdminDetails.lastName}`}</div>
                <div style={{color: "#929191"}}>{`${AppStore.getAdminDetails.username}`}</div>
            </div>
            <div className="flex_row" onClick={logout}
                 style={{justifyContent: "center", flex: "1", fontSize: "14px"}}>
                Log out
            </div>
        </div>

        <List
            style={{height: "100%", overflowY: "scroll"}}
            dataSource={AppStore.getLeadBots}
            renderHeader={() => <p style={{paddingLeft: "10px"}}>Projects {`(${AppStore.getLeadBots.length})`}</p>}
            renderRow={(row, idx) => (

                <li key={row.id} className="list-item">
                    <div className="list-item__left">
                        {
                            row.imageURL ? (
                                <img className="list-item__thumbnail" src={row.imageURL} alt="Cute kitten"/>) : (
                                <img className="list-item__thumbnail" alt="Exceed.ai"
                                     src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAIAAAADnC86AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3wwJCB8v/9zErgAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAAvSURBVFjD7c0BDQAACAMgtX+KJzWGm4MCdJK6MHVELBaLxWKxWCwWi8VisVj8MV7qBgI2A8rYpgAAAABJRU5ErkJggg=="/>)
                        }
                    </div>

                    <div className="list-item__center" onClick={() => switchProject(row.id, ExceedApi, history, "/")}>
                        {row.name}
                    </div>
                </li>

            )}
        />

    </div>
}